import React from "react";

import img1 from "../../images/activities/education/img (34).jpg";
import img2 from "../../images/activities/humanitarian/img (35).jpg";
import img3 from "../../images/activities/humanitarian/img (23).jpg";
import img4 from "../../images/oha/img (4).jpg";
import img5 from "../../images/oha/img (14).jpg";
import img6 from "../../images/oha/img (9).jpg";

const OurWork = () => {
  const workAreas = [
    {
      icon: "🏫",
      title: "School Infrastructure",
      description: "Building and renovating school facilities to provide safe, modern learning environments for Afghan students. We construct classrooms, libraries, and recreational spaces that foster education and growth.",
      image: img1,
      imageAlt: "School building construction"
    },
    {
      icon: "📚",
      title: "Educational Resources",
      description: "Supplying schools with essential materials including textbooks, learning supplies, computers, and teaching tools. We ensure students have access to the resources they need to succeed.",
      image: img2,
      imageAlt: "Educational books and supplies"
    },
    {
      icon: "👨‍🏫",
      title: "Teacher Support",
      description: "Providing professional development, training programs, and fair compensation for educators. We believe quality teaching is the foundation of excellent education.",
      image: img3,
      imageAlt: "Teacher training session"
    },
    {
      icon: "💡",
      title: "Student Programs",
      description: "Creating scholarship opportunities, mentorship programs, and extracurricular activities that help students develop holistically and pursue their dreams.",
      image: img4,
      imageAlt: "Students in learning program"
    },
    {
      icon: "🤝",
      title: "Community Engagement",
      description: "Working directly with local communities to understand their needs and involve families in the educational journey. We build lasting partnerships that create sustainable change.",
      image: img5,
      imageAlt: "Community meeting and engagement"
    },
    {
      icon: "🌍",
      title: "Future Leaders",
      description: "Empowering the next generation of Afghan leaders through education, critical thinking, and civic engagement programs that prepare students to transform their communities.",
      image: img6,
      imageAlt: "Young students participating in leadership activities"
    }
  ];

  return (
    <div className="our-work" data-aos="fade-up">
      <h2 data-aos="fade-down" data-aos-delay="100">
        What We Do
      </h2>
      <div className="work-grid">
        {workAreas.map((area, index) => (
          <div 
            key={index} 
            className="work-card"
            data-aos="fade-up"
            data-aos-delay={200 + (index * 100)}
          >
            <div className="work-image">
              <img 
                src={area.image} 
                alt={area.imageAlt}
                loading="lazy"
              />
            </div>
            <div className="work-content">
              <span className="work-icon">{area.icon}</span>
              <h3>{area.title}</h3>
              <p>{area.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurWork;